<div class="toggle" #radialContainer (click)="menuClick($event)">
  <i class="material-icons fa-plus" #radialPlus>add</i>
  <div class="menu" #radialMenu>
    @for (button of buttons; track button) {
      <a (click)="onRadClick(button)">
        <div class="badge-container">
          @if (!button.badgeHidden && button.badgeValue) {
            <div class="badge">
              <p>{{ button.badgeValue }}</p>
            </div>
          }
          <button [class.disabled]="!button.enabled">
            <img [src]="button.svgImage" [alt]="button.name" />
          </button>
        </div>
      </a>
    }
  </div>
</div>
